import { FormFieldSchema } from '../../../components/FormRenderer/types';
import { fineTypeOption } from './constant';

export function getLateFeeConfigSchema(): FormFieldSchema[] {
  return [
    {
      name: 'general',
      label: 'General',
      type: 'section',
      children: [
        {
          name: 'fineType',
          label: 'Fine Type',
          type: 'dropdown',
          options: fineTypeOption
        },
        {
          name: 'lateFeeCharges.amount',
          label: 'Amount',
          type: 'input',
          placeholder: 'Enter Amount',
          shouldRender: (formData) => formData.fineType === 'PER_DAY'
        },
        {
          name: 'lateFeeCharges.percentage',
          label: 'Percentage',
          type: 'input',
          placeholder: 'Enter Percentage',
          shouldRender: (formData) => formData.fineType === 'PER_MONTH'
        },
        {
          name: 'chequeBounceCharges',
          label: 'Cheque Bounce Charges',
          type: 'input',
          placeholder: 'Enter Cheque Bounce Charges'
        },

        {
          name: 'enachBounceCharges',
          label: 'Enach Bounce Charges',
          type: 'input',
          placeholder: 'Enter Enach Bounce Charges'
        },
        {
          name: 'maxLateFee',
          label: 'Max Late Fee',
          type: 'input',
          placeholder: 'Enter Max Late Fee',
          required: false
        },
        {
          name: '',
          label: '',
          type: 'empty'
        },
        {
          name: 'proRatedConfig.enabled',
          type: 'checkbox',
          label: 'Enable Prorated Config',
          shouldRender: (formData) => formData.fineType === 'PER_MONTH'
        },
        {
          name: 'proRatedConfig.proRateAfterCycles',
          type: 'input',
          placeholder: 'Enter Prorated Cycle',
          label: 'Pro-rate after cycles',
          shouldRender: (formData) =>
            formData.proRatedConfig.enabled &&
            formData.fineType === 'PER_MONTH',
          helperText:
            'For e.g. if Fine Type is per month, and pro rate after cycles is set as 1, then pro-rated logic will be applied after 1st month.'
        }
      ]
    }
  ];
}
